module.exports = __webpack_public_path__ + "img/team-3.7f29b366.jpg";